import React from "react";
import { Link } from "react-router";
import { FontIcon } from "@companion-core/shared/app/Components/FontIcon";
import { RegisterContent } from "./Content/RegisterContent";
import { trackClickHelp } from "@companion-core/shared/app/tracking/register";
import { getPreviousStep } from "@companion-core/shared/app/Utils/dynamicForm";
import { useRegister } from "@companion-core/shared/app/Components/SignUp/hooks/useRegister";
import "@companion-core/web/src/Assets/Styles/scss/register.scss";

export const Register = () => {
  const {
    t,
    currentForm,
    currentPage,
    currentStep,
    formTree,
    registerContent,
    resetWizard,
    setCurrentForm,
    setCurrentStep,
    setRegisterContent,
    vcesEnabled,
  } = useRegister();

  const handleBackButton = () => {
    if (currentForm && currentStep && currentStep?.order > 1) {
      const { step, jsonForm } = getPreviousStep(currentForm, currentStep.order, formTree);
      setCurrentForm(jsonForm);
      setCurrentStep(step);
    } else {
      setRegisterContent(vcesEnabled ? "vces" : "register");
      resetWizard();
    }
  };

  const RegisterHeader = () => {
    return (
      <div className="register__header">
        {!["register", "vces"].includes(registerContent ?? "") ? (
          <span
            data-testid="register__header--back-button"
            className="register__header-back-button cursor-pointer"
            onClick={handleBackButton}>
            <FontIcon name="JP-Arrow-left-bold" size={24} />
            {t("register.back-button.label")}
          </span>
        ) : (
          <></>
        )}
      </div>
    );
  };

  return (
    <div data-testid="register" className="register">
      <RegisterHeader />
      <div className="register__container">
        <RegisterContent
          state={registerContent ?? ""}
          redirectCallback={() => setRegisterContent(vcesEnabled ? "vces" : "register")}
        />
        <div className="register__need-help" data-testid="register__need-help">
          <span className="body-text-8">
            {t("register.links.help.pre")} {t("register.links.help.post")}
            <Link
              data-testid="register__need-help--link"
              to="/need-help"
              className="register__need-help-link body-text-7"
              onClick={() => trackClickHelp(currentPage)}>
              {t("register.links.help.link")}
            </Link>
          </span>
        </div>
      </div>
    </div>
  );
};
